import { TextInput } from '#app/components/TextInput/TextInput.js';
import { ComponentProps } from 'react';

type TaxRateInput = Omit<
  ComponentProps<typeof TextInput<'percent'>>,
  'variant'
>;

export const TaxRateInput = ({
  error,
  inputRef,
  onBlur,
  onValueChange,
  value,
}: TaxRateInput) => {
  return (
    <TextInput
      allowDecimals
      error={error}
      inputRef={inputRef}
      label={{ position: 'inner', text: 'Tax rate' }}
      onBlur={onBlur}
      onValueChange={onValueChange}
      placeholder="20%"
      resize={undefined}
      value={value}
      variant="percent"
    />
  );
};
